import {gsap, MotionPathPlugin} from "gsap/all";
import {BaseGameMars} from "../base/BaseGameMars";
import {Rover} from "./Rover";
import seedrandom from "seedrandom";

gsap.registerPlugin(MotionPathPlugin)

const rng = seedrandom("laviecestuneboitedechocolat");

const ROVERS_IN_LOOP = 6;

// Constructor
export class BuildYourRoverSecondary extends BaseGameMars {

  constructor(side) {
    super(`data/build-your-rover.json`, 'build-your-rover-secondary');
    gsap.registerPlugin();
    this.side = side;
    this.pauseBetweenScreensInSec = 0;
    this.roverCount = $("#rover-container > div").length;
    this.roverIndex = 0;
  }

  initGame() {

    // Audio example
    // setInterval(() => app.audio.play("audio/click.wav", 1, true), 1000)

    super.initGame();
    this.initMQTTScreenCommunication("rover");

    // Keep track of the rover sent to Mars
    this.rovers = [];

    // Init a bunch of rovers
    $("#rover-container > div").each((index, element) => {
      const rover = new Rover(app, `mars-rover-${index}`, $(element));
      rover.inUsed = false;
      rover.index = index;
      rover.$container.addClass("is-hidden");
      this.rovers.push(rover);
    })

    // Load pause between screens from app settings
    this.pauseBetweenScreensInSec = this.data.pause_between_screens_in_sec;
    console.log(`pauseBetweenScreensInSec: ${this.pauseBetweenScreensInSec}`);

    // Setup side
    if (this.side === "right") $("[data-side='left']").remove();
    else $("[data-side='right']").remove();

    // Use this to test and refresh right side
    // if (this.side === "right") {
    //   setTimeout(() => {
    //     app.publishScreenBridgeMessage("rover", 'A0A1060602');
    //   }, 500)
    // }

    // or simply paste this in the console: app.publishScreenBridgeMessage("rover", 'A0A1060602');
  }

  onScreenBridgeMessage(messageString) {
    console.log("Received message from MQTT", messageString)
    this.loadRover(messageString);
  }

  loadRover(code) {
    const firstUnusedRover = this.rovers.find(rover => !rover.inUsed);

    if (firstUnusedRover) {
      firstUnusedRover.inUsed = true;
      firstUnusedRover.index = this.roverIndex++;
      console.log("firstUnusedRover Rover", firstUnusedRover.index);
      const uniqueId = firstUnusedRover.$container.data("unique-id");
      console.log(`Loading Rover for ${code} into ${uniqueId}`);

      // Even if we clone, we still need to check if the img are ready
      const images = firstUnusedRover.$container.find("img").toArray();
      const imagePromises = images.map(img => {
        if (img.complete) return Promise.resolve();
        return new Promise(resolve => {
          $(img).one("load error", resolve);
        });
      });

      // Once all images are loaded, apply config and reveal the rover
      Promise.all(imagePromises).then(() => {
        requestAnimationFrame(() => {
          firstUnusedRover.applyConfig(code);
          firstUnusedRover.$container.removeClass('is-hidden');

          this.animateRover(firstUnusedRover);
        });
      });

    } else {
      console.log(`No more rovers available to load ${code}.`);
    }

    // If we're not currently on screen 2, go to it
    if (this.currentScreen !== 2) {
      this.goToScreen(2);
    }
  }

  checkTimer() {
    // Disable checkTimer for this app
    // Otherwise, we have gsap errors, since we don't have #still-there element
    this.lastClick = millis();
    super.checkTimer()
  }

  initScreen(screenId) {
    const targetScreenNoSuffix = parseInt(screenId.toString().split("-")[0]);
    BaseGameMars.killTimeline(this.currentTimeline)
    this.currentTimeline = gsap.timeline();
  }

  animateRover(rover) {

    const tl = gsap.timeline({
      onComplete: () => {
        // Define if current rover should loop (only keep 6 in loop)
        const shouldLoop = (rover.index > this.roverIndex - ROVERS_IN_LOOP);

        if (shouldLoop) {
          tl.restart();
        } else {
          console.log(`Rover ${rover.index} is now free`, rover);
          rover.inUsed = false;
          gsap.killTweensOf($roverElement.find("*"));
          gsap.killTweensOf($roverElement);
          gsap.killTweensOf($activeWheels);
        }
      }
    });

    // tl.timeScale(8)

    const $roverElement = rover.$container;

    // Find the active wheel images within this specific rover clone
    const $activeWheels = $roverElement.find('.option-group[data-category="wheels"] .option-slide.is-active .option-image');

    // Define a random translation duration between 10.5 and 14.5 seconds
    const translationDuration = 10.5 + (rng() * 4);

    // Initial position
    gsap.set($roverElement, {
      x: "-" + $roverElement.outerWidth(),
      scaleX: -1, // Make the rover face right
    });

    // Spin wheels continuously
    if ($activeWheels.length) {
      gsap.killTweensOf($activeWheels)
      gsap.to($activeWheels, {
        rotation: "-=360",
        duration: 1.5,
        repeat: -1,
        ease: "linear",
      });
    }

    // Move to left
    gsap.killTweensOf($roverElement)

    // Move the rover along a straight horizontal path using GSAP’s MotionPathPlugin
    const path = $(".rover-path path").attr("d");

    tl.to($roverElement, {
      duration: translationDuration,
      // delay: 0,
      ease: "linear",
      motionPath: {
        path: path,
        autoRotate: true,
        orientation: "none",
      },
    }, (this.side === 'right') ? translationDuration + this.pauseBetweenScreensInSec : 0);

    tl.add(() => console.log(`Rover ${rover.index} animation complete`), (translationDuration * 2 + this.pauseBetweenScreensInSec));
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   */
  reset(screenId) {

    // Reset variable and timeline
    this.killTimeline(this.currentTimeline);
    this.killTimeline(this.timeline);

    const resetCallback = () => {
      // TODO Things that reset AFTER goToScreen

      // Kill animations, and remove rovers
      Object.values(this.rovers).forEach(rover => {
        rover.inUsed = false;
        rover.$container.addClass("is-hidden");
        gsap.killTweensOf(rover.$container.find("*"));
        gsap.killTweensOf(rover.$container);
      });
    }

    // Super
    return super.reset(screenId, resetCallback);
  }

}
